import { css } from '@emotion/react';
import { math } from 'polished';
import {
  breakpointInfix,
  MediaBreakpointUp,
} from '../mixins/_breakpoints.mixin';


export default $ => css(Object.keys($.gridBreakpoints).map($breakpoint => {
  const infix = breakpointInfix($, $breakpoint, $.gridBreakpoints);
  const rules = [];
  // console.log("$.spacers, ", $.spacers)
  Object.entries({margin: 'm', padding: 'p'}).forEach(([prop, abbrev]) => {
    Object.entries($.spacers).forEach(([size, length]) => {
      rules.push(css`
        .${abbrev}${infix}-${size} { ${prop}: ${length} !important; }
        .${abbrev}t${infix}-${size},
        .${abbrev}y${infix}-${size} {
          ${prop}-top: ${length} !important;
        }
        .${abbrev}r${infix}-${size},
        .${abbrev}x${infix}-${size} {
          ${prop}-right: ${length} !important;
        }
        .${abbrev}b${infix}-${size},
        .${abbrev}y${infix}-${size} {
          ${prop}-bottom: ${length} !important;
        }
        .${abbrev}l${infix}-${size},
        .${abbrev}x${infix}-${size} {
          ${prop}-left: ${length} !important;
        }
      `)
    });
  });

  // Negative margins (e.g., where `.mb-n1` is negative version of `.mb-1`)
  Object.entries($.spacers).forEach(([size, length]) => {
    if (size !== 0) {
      const nlength = math(`-${length}`);
      rules.push(css`
        .m${infix}-n${size} { margin: ${nlength} !important; }
        .mt${infix}-n${size},
        .my${infix}-n${size} {
          margin-top: ${nlength} !important;
        }
        .mr${infix}-n${size},
        .mx${infix}-n${size} {
          margin-right: ${nlength} !important;
        }
        .mb${infix}-n${size},
        .my${infix}-n${size} {
          margin-bottom: ${nlength} !important;
        }
        .ml${infix}-n${size},
        .mx${infix}-n${size} {
          margin-left: ${nlength} !important;
        }
      `);
    }
  });

  // Some special margin utils
  rules.push(css`
    .m${infix}-auto { margin: auto !important; }
    .mt${infix}-auto,
    .my${infix}-auto {
      margin-top: auto !important;
    }
    .mr${infix}-auto,
    .mx${infix}-auto {
      margin-right: auto !important;
    }
    .mb${infix}-auto,
    .my${infix}-auto {
      margin-bottom: auto !important;
    }
    .ml${infix}-auto,
    .mx${infix}-auto {
      margin-left: auto !important;
    }
  `);
  return new MediaBreakpointUp($breakpoint).include($, css(rules));
}));
